import { observer } from 'mobx-react';
import clsx from 'clsx';
import useJoinSmsCheck from '../useJoinUserInfo';
import { MAX_NICKNAME_LENGTH, MAX_PHONE_NUMBER_LENGTH_WITH_HYPHEN } from '@/consts';

interface IProps {
  onClick: () => void;
}

const JoinUserInfoView = observer(({ onClick }: IProps): JSX.Element => {
  const {
    phone,
    phoneNumGuideMsg,
    isCompleteBtnDisabled,
    nickname,
    nicknameGuideMsg,
    onChangePhoneNumber,
    onClickRequestBtn,
    onChangeNickname,
    onClickNicknameCheckBtn,
    onClickCompleteBtn,
  } = useJoinSmsCheck(onClick);

  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="signup-title heading-4 font-bold">회원가입 정보 입력</h1>

        <form className="signup-form">
          <div className="form-group">
            <label htmlFor="country" className="form-label text-base font-medium">
              국가 번호를 선택해주세요.
            </label>
            <div className="select-wrapper">
              <img src="./images/flag-korea.png" alt="국기" className="select-flag" />
              <select id="country" name="country" className="form-select" disabled>
                <option value="+82">한국 (+82)</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="phone" className="form-label text-base font-medium">
              휴대폰번호를 입력해주세요.
            </label>
            <div className="input-with-button">
              <span className="input-prefix text-base font-normal">(+82)</span>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="010-0000-0000"
                className="form-input-inline"
                value={phone}
                onChange={onChangePhoneNumber}
                maxLength={MAX_PHONE_NUMBER_LENGTH_WITH_HYPHEN}
              />
              <button type="button" className="btn-inline text-sm font-medium" onClick={onClickRequestBtn}>
                중복확인
              </button>
            </div>
            {phoneNumGuideMsg && <p className="error-message phone-error text-sm font-normal">{phoneNumGuideMsg}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="nickname" className="form-label text-base font-medium">
              닉네임을 입력해주세요.
            </label>
            <div className="input-with-button">
              <input
                type="text"
                id="nickname"
                name="nickname"
                placeholder="닉네임 입력"
                className="form-input-inline"
                value={nickname}
                onChange={onChangeNickname}
                maxLength={MAX_NICKNAME_LENGTH}
                pattern="^[a-zA-Z0-9가-힣]+$"
              />
              <button type="button" className="btn-inline text-sm font-medium" onClick={onClickNicknameCheckBtn}>
                중복확인
              </button>
            </div>
            {nicknameGuideMsg && <p className="error-message nickname-error text-sm font-normal">{nicknameGuideMsg}</p>}
          </div>
          <button
            type="button"
            className={clsx('btn-primary signup-button text-lg font-semibold', {
              active: !isCompleteBtnDisabled,
              default_cursor: isCompleteBtnDisabled,
            })}
            disabled={isCompleteBtnDisabled}
            onClick={onClickCompleteBtn}
            //   className="btn-primary signup-button text-lg font-semibold"
            id="nextBtn"
          >
            다음
          </button>
        </form>
      </div>
    </div>
  );
});

export default JoinUserInfoView;
